import React, { useState, useEffect } from 'react';
import { Button } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import NavBar from '../../../component/b2c/navBar/navBar';
import { useMyContext } from '../../../context/MyContext';
import Sidebar from '../../../component/b2b/sideBar/b2bSideBar';
import { FaCcVisa, FaCcMastercard } from 'react-icons/fa';
import '../../../css/custom-scrollbar.css';
import { IoClose } from "react-icons/io5";
import { Base_Url, payment, walletRecharge, grandTotalAmount, updatewalletAmount, amountUpdate } from '../../../config/config';
import axios from 'axios';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import Loader from '../../../component/spinner/spinner';
import { X, CreditCard, User, ArrowUp, CheckCircle, Wallet, Truck, History, Settings } from 'lucide-react';

const B2bWalletRecharge = () => {
  const [amount, setAmount] = useState('');
  const [error, setError] = useState('');
  const role = localStorage.getItem('role');
  const [loader, setLoader] = useState(false);
  const [coupon, setCoupon] = useState('');
  const [paymentUrl, setPaymentUrl] = useState('');
  const { isDarkMode, isToggleSidebar } = useMyContext();
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const cus_id = localStorage.getItem('cus_id');
  const location = useLocation();
  const [totalAmount, setTotalAmount] = useState(0);
  const [currentBalanace, setCurrentBalanace] = useState(0);

  // New state for update wallet popup
  const [isUpdatePopupOpen, setIsUpdatePopupOpen] = useState(false);
  const [updateData, setUpdateData] = useState({
    txn_id: '',
    user_id: '',
    amount: '',
    type: 'add'
  });
  const [updateLoader, setUpdateLoader] = useState(false);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data && event.data.status === "paid") {
        setTimeout(() => {
          window.location.href = "";
          setPaymentUrl('');
        }, 3000);
      }
    };
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  useEffect(() => {
    if (role === "admin") {
      getTotalAmount();
    }
    getPayment();
  }, []);

  const getTotalAmount = async () => {
    const uri = Base_Url + "admin/" + grandTotalAmount;
    try {
      const token = localStorage.getItem('token');
      const cusid = localStorage.getItem('cus_id');

      const response = await fetch(uri, {
        method: "GET",
        headers: {
          "token": token,
          "cus_id": cusid,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();
      if (data.status === "SUCCESS") {
        setTotalAmount(data.grand_total);
      } else {
        console.error("Error:", data);
      }
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  const getPayment = async () => {
    const url = Base_Url + payment
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cus_id,
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      if (data.status === "success") {
        setCurrentBalanace(data.totalamount);
      } else {
        toast.error(`Error: ${data.message} (Code: ${data.code})`);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
  };

  const handleRecharge = async (e) => {
    e.preventDefault();

    if (!amount || isNaN(amount)) {
      toast.error('Please enter a valid amount');
      return;
    }

    // Calculate service charge and GST
    const serviceCharge = (amount * 0.025).toFixed(2);
    const gst = (serviceCharge * 0.18).toFixed(2);
    const totalAmount = (parseFloat(amount) - parseFloat(serviceCharge) - parseFloat(gst)).toFixed(2);

    const maxDiscount = 5000;
    const discountRate = 0.05;
    const creditCardDiscountText = parseFloat(amount) <= maxDiscount
      ? `Recharge ₹5,000 or more and get 5% cashback — up to ₹250! `
      : '';

    // Show SweetAlert confirmation
    const result = await Swal.fire({
      title: '<span style="color: #000; font-weight: 600;">Wallet Recharge</span>',
      html: `
        <div style="text-align: left; padding: 10px; border-radius: 8px; background-color: #f8f9fa;">
          <div style="display: flex; justify-content: center; margin-bottom: 15px;">
            <div style="background-color: #000; color: white; border-radius: 50%; width: 60px; height: 60px; display: flex; align-items: center; justify-content: center; font-size: 24px;">
              <i class="fas fa-wallet"></i>
            </div>
          </div>
          
          <div style="margin-bottom: 15px; padding: 15px; border-radius: 8px; background-color: white; box-shadow: 0 2px 5px rgba(0,0,0,0.08);">
            <p style="font-size: 14px; margin-bottom: 10px;">Recharge Amount: <span style="float: right; font-weight: 600; color: #000;">₹${amount}</span></p>
            <p style="font-size: 12px; color: #666; margin-bottom: 5px;">Service charge (2.5%): <span style="float: right;">₹${serviceCharge}</span></p>
            <p style="font-size: 12px; color: #666; margin-bottom: 5px;">GST (18%): <span style="float: right;">₹${gst}</span></p>
            <hr style="border-top: 1px dashed #ddd; margin: 10px 0;">
            <p style="font-size: 14px; margin: 0; font-weight: 600;">Total to Wallet: <span style="float: right; color: #2e7d32;">₹${totalAmount}</span></p>
          </div>
          
          <div style="background-color: #e3f2fd; padding: 10px; border-radius: 8px; border-left: 4px solid #1976d2; margin-bottom: 10px;">
            <p style="margin: 0; color: #0d47a1; display: flex; align-items: center; font-size: 12px;">
              <i class="fas fa-credit-card" style="margin-right: 8px;"></i>
              <span style="font-weight: 500;">${creditCardDiscountText}</span>
            </p>
          </div>
          
          <div style="background-color: #fff3e0; padding: 10px; border-radius: 8px; border-left: 4px solid #ff9800;">
            <p style="margin: 0; color: #e65100; font-size: 12px; display: flex; align-items: center;">
              <i class="fas fa-exclamation-circle" style="margin-right: 8px;"></i>
              <span>Additional charges may apply when using a credit card.</span>
            </p>
          </div>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: '<i class="fas fa-check-circle"></i> Proceed',
      cancelButtonText: '<i class="fas fa-times-circle"></i> Cancel',
      confirmButtonColor: '#000000',
      cancelButtonColor: '#666666',
      buttonsStyling: true,
      customClass: {
        container: 'my-swal-container',
        popup: 'my-swal-popup',
        header: 'my-swal-header',
        title: 'my-swal-title',
        closeButton: 'my-swal-close-button',
        content: 'my-swal-content',
        actions: 'my-swal-actions',
        confirmButton: 'my-swal-confirm-button',
        cancelButton: 'my-swal-cancel-button',
        footer: 'my-swal-footer'
      },
      showClass: {
        popup: 'animate__animated animate__fadeIn animate__faster'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOut animate__faster'
      }
    });

    if (result.isConfirmed) {
      try {
        setLoader(true);
        const uri = Base_Url + walletRecharge;
        const response = await axios.post(
          uri,
          { amount },
          {
            headers: {
              token: token,
              cus_id: cus_id,
              "Content-Type": "application/json"
            },
          }
        );

        if (response.data.status === "SUCCESS") {
          const url = response.data?.data?.link;
          setPaymentUrl(url);
          setAmount('');
          setCoupon('');
          setLoader(false);
        } else {
          toast.error(response.data.message || 'Recharge failed');
          setLoader(false);
        }
      } catch (error) {
        toast.error(error.response?.data?.message || 'An error occurred');
        setLoader(false);
      }
    }
  };

  const handleOpenUpdatePopup = () => {
    setIsUpdatePopupOpen(true);
    setUpdateData(prevState => ({
      ...prevState,
    }));
  };

  const handleCloseUpdatePopup = () => {
    setIsUpdatePopupOpen(false);
    setUpdateData({
      txn_id: '',
      user_id: '',
      amount: '',
      type: 'add'
    });
  };

  const handleUpdateInputChange = (e) => {
    const { name, value } = e.target;
    setUpdateData({
      ...updateData,
      [name]: value
    });
  };

  const handleUpdateWallet = async (e) => {
    e.preventDefault();

    if (!updateData.txn_id.trim()) {
      toast.error('Transaction ID is required');
      return;
    }

    if (!updateData.user_id.trim()) {
      toast.error('Customer ID is required');
      return;
    }

    try {
      setUpdateLoader(true);
      const uri = Base_Url + amountUpdate;

      const response = await axios.post(
        uri,
        updateData,
        {
          headers: {
            token: token,
            cus_id: cus_id,
            "Content-Type": "application/json"
          },
        }
      );

      if (response.data && response.data.status === "SUCCESS") {
        toast.success(response.data.message);
        handleCloseUpdatePopup();
        getPayment();
      } else {
        toast.error(
          response.data?.message ||
          response.data?.messsge ||
          response.data?.messages?.error ||
          'Failed to update wallet'
        );
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
        error.response?.data?.messsge ||
        error.response?.data?.messages?.error ||
        'An error occurred'
      )
    } finally {
      setUpdateLoader(false);
    }
  };

  const viewHistory = () => {
    navigate('/b2b/payments/topuphistory');
  };

  const viewShipmentCharges = () => {
    navigate('/b2b/payments/shippingCharges');
  };

  const handleAmountChange = (e) => {
    const val = e.target.value;

    if (val > 50000) {
      toast.error("Amount cannot exceed ₹50,000");
      setError("Amount cannot exceed ₹50,000");
    } else {
      setError('');
      setAmount(val);
    }
  };
  const glass =
    "backdrop-blur-2xl backdrop-saturate-150 bg-white/50 dark:bg-white/[0.06] " +
    "border border-white/60 dark:border-white/10 " +
    "shadow-[0_8px_32px_rgba(31,41,55,0.08)]";
  return (
    <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'bg-black' : 'bg-white'}`}>
      <div className="pointer-events-none absolute -top-32 -left-24 h-96 w-96 rounded-full bg-indigo-200/30 dark:bg-indigo-500/10 blur-3xl" />

      <NavBar />

      <div className="flex flex-1 overflow-hidden">
<div
                        className={`${isToggleSidebar ? "w-64" : "w-20"} m-3 rounded-3xl ${glass} overflow-hidden transition-all duration-300 ease-in-out flex-shrink-0`}>
                        <Sidebar />
                    </div>

        <div className={`flex-1 p-3 overflow-hidden ${isDarkMode ? 'bg-black' : 'bg-gray-100'}`}>
          <div className="max-w-6xl mx-auto h-full grid grid-cols-1 lg:grid-cols-5 gap-3">

            {/* Main Content Section */}
            <div className={`lg:col-span-3 border shadow-sm rounded-xl p-4 relative overflow-hidden h-fit
              ${isDarkMode
                ? 'bg-gradient-to-br from-[#0b0b14] via-[#0d0d18] to-[#0b0b14] border-indigo-500/20 shadow-[0_8px_40px_rgba(79,70,229,0.15)]'
                : 'bg-white border-black/10'
              }`}>

              {/* Header */}
              <div className={`flex items-center justify-center gap-2 mb-4 relative z-10 rounded-xl py-2 px-4 border
                ${isDarkMode
                  ? 'bg-gradient-to-r from-indigo-600 via-purple-600 to-indigo-600 border-indigo-400/40 shadow-lg shadow-indigo-900/50'
                  : 'bg-[#007DCC] border-black/20'
                }`}>
                <FaCcVisa className={isDarkMode ? 'text-white' : 'text-white'} size={16} />
                <FaCcMastercard className={isDarkMode ? 'text-white' : 'text-white'} size={16} />
                <span className={`font-bold text-xs tracking-wide ${isDarkMode ? 'text-white' : 'text-white'}`}>Wallet Recharge</span>
              </div>

              {/* Payment Modal */}
              {paymentUrl && (
                <div className="fixed inset-0 z-50 bg-white">
                  <iframe
                    src={paymentUrl}
                    width="100%"
                    height="100%"
                    className="border-none"
                  />
                </div>
              )}

              {/* Current Balance Card */}
              <div className="mb-3 relative z-10">
                <div className={`p-3 w-full rounded-xl text-center border
                  ${isDarkMode
                    ? 'border-indigo-500/30 bg-gradient-to-br from-indigo-500/10 via-purple-500/5 to-transparent backdrop-blur-sm'
                    : 'border-black/10 bg-black/5'
                  }`}>
                  <div className="flex items-center justify-center gap-1.5 mb-1">
                    <div className={`w-5 h-5 rounded-full flex items-center justify-center
                      ${isDarkMode ? 'bg-gradient-to-br from-indigo-500 to-purple-600' : 'bg-blue-600'}`}>
                      <span className={`font-bold text-[10px] ${isDarkMode ? 'text-white' : 'text-white'}`}>₹</span>
                    </div>
                    <h3 className={`text-[10px] font-semibold uppercase tracking-wide ${isDarkMode ? 'text-indigo-200/80' : 'text-black/60'}`}>Current Balance</h3>
                  </div>
                  <p className={`text-2xl font-black ${isDarkMode ? 'text-white drop-shadow-[0_0_12px_rgba(99,102,241,0.5)]' : 'text-black'}`}>
                    ₹{currentBalanace}
                  </p>
                </div>
              </div>

              {/* Admin Update Button */}
              {role === "admin" && (
                <div className="mb-3 relative z-10">
                  <Button
                    onClick={handleOpenUpdatePopup}
                    variant="contained"
                    fullWidth
                    startIcon={<Settings size={14} />}
                    sx={{
                      background: isDarkMode
                        ? 'linear-gradient(90deg, #4f46e5 0%, #7c3aed 100%)'
                        : '#007DCC',
                      color: isDarkMode ? '#ffffff' : '#ffffff',
                      textTransform: 'capitalize',
                      borderRadius: '10px',
                      padding: '6px 16px',
                      fontSize: '11px',
                      fontWeight: 600,
                      boxShadow: isDarkMode ? '0 4px 20px rgba(79,70,229,0.4)' : 'none',
                      border: `1px solid ${isDarkMode ? 'rgba(139,92,246,0.4)' : 'rgba(0,0,0,0.2)'}`,
                      '&:hover': {
                        background: isDarkMode
                          ? 'linear-gradient(90deg, #4338ca 0%, #6d28d9 100%)'
                          : '#1a1a1a',
                      },
                    }}
                  >
                    Update Wallet Balance
                  </Button>
                </div>
              )}

              {/* Action Buttons */}
              <div className="grid grid-cols-2 gap-2 mb-4 relative z-10">
                <Button
                  onClick={viewShipmentCharges}
                  variant="outlined"
                  startIcon={<Truck size={13} />}
                  sx={{
                    borderColor: isDarkMode ? 'rgba(99,102,241,0.5)' : 'rgba(0,0,0,0.3)',
                    color: isDarkMode ? '#c7d2fe' : '#000000',
                    textTransform: 'capitalize',
                    borderRadius: '10px',
                    padding: '5px 10px',
                    fontSize: '10px',
                    fontWeight: 600,
                    '&:hover': {
                      borderColor: isDarkMode ? '#a5b4fc' : '#000000',
                      background: isDarkMode ? 'rgba(99,102,241,0.15)' : 'rgba(0,0,0,0.05)',
                    },
                  }}
                >
                  Shipment Charges
                </Button>

                <Button
                  onClick={viewHistory}
                  variant="outlined"
                  startIcon={<History size={13} />}
                  sx={{
                    borderColor: isDarkMode ? 'rgba(99,102,241,0.5)' : 'rgba(0,0,0,0.3)',
                    color: isDarkMode ? '#c7d2fe' : '#000000',
                    textTransform: 'capitalize',
                    borderRadius: '10px',
                    padding: '5px 10px',
                    fontSize: '10px',
                    fontWeight: 600,
                    '&:hover': {
                      borderColor: isDarkMode ? '#a5b4fc' : '#000000',
                      background: isDarkMode ? 'rgba(99,102,241,0.15)' : 'rgba(0,0,0,0.05)',
                    },
                  }}
                >
                  Topup History
                </Button>
              </div>

              {/* Recharge Form */}
              <form onSubmit={handleRecharge} className="space-y-3 relative z-10">
                <div className="space-y-3">
                  <div>
                    <label htmlFor="amount" className={`block text-[10px] font-semibold mb-1.5 flex items-center gap-1.5 ${isDarkMode ? 'text-indigo-200/80' : 'text-black/70'}`}>
                      <span className={`w-1 h-1 rounded-full ${isDarkMode ? 'bg-indigo-400' : 'bg-black'}`}></span>
                      Custom Amount
                    </label>
                    <div className="relative">
                      <span className={`absolute left-3 top-1/2 -translate-y-1/2 font-bold text-sm ${isDarkMode ? 'text-indigo-300' : 'text-black/60'}`}>₹</span>
                      <input
                        type="number"
                        id="amount"
                        value={amount}
                        onChange={handleAmountChange}
                        placeholder="Enter amount"
                        className={`w-full pl-8 pr-3 py-2 border text-sm rounded-lg transition-all duration-200 font-medium
                          ${error
                            ? 'border-red-500/60'
                            : isDarkMode
                              ? 'border-indigo-500/30 bg-black/60 text-white placeholder-indigo-300/40 focus:border-indigo-400 focus:ring-1 focus:ring-indigo-500/60 focus:shadow-[0_0_20px_rgba(99,102,241,0.25)]'
                              : 'border-black/20 bg-white text-black placeholder-black/40 focus:border-black focus:ring-1 focus:ring-black'
                          }`}
                        required
                      />
                    </div>
                    {error && <p className="text-[10px] text-red-500 mt-1">{error}</p>}
                  </div>

                  <div>
                    <label htmlFor="coupon" className={`block text-[10px] font-semibold mb-1.5 flex items-center gap-1.5 ${isDarkMode ? 'text-indigo-200/80' : 'text-black/70'}`}>
                      <span className={`w-1 h-1 rounded-full ${isDarkMode ? 'bg-indigo-400' : 'bg-black'}`}></span>
                      Apply Coupon <span className="text-[9px] font-normal opacity-50">(optional)</span>
                    </label>
                    <div className="relative">
                      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm opacity-50">🎫</span>
                      <input
                        type="text"
                        id="coupon"
                        value={coupon}
                        onChange={(e) => setCoupon(e.target.value)}
                        placeholder="Enter coupon code"
                        className={`w-full pl-9 pr-3 py-2 border text-sm rounded-lg transition-all duration-200 font-medium
                          ${isDarkMode
                            ? 'border-indigo-500/30 bg-black/60 text-white placeholder-indigo-300/40 focus:border-indigo-400 focus:ring-1 focus:ring-indigo-500/60 focus:shadow-[0_0_20px_rgba(99,102,241,0.25)]'
                            : 'border-black/20 bg-white text-black placeholder-black/40 focus:border-black focus:ring-1 focus:ring-black'
                          }`}
                      />
                    </div>
                  </div>
                </div>

                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  sx={{
                    background: isDarkMode
                      ? 'linear-gradient(90deg, #4f46e5 0%, #7c3aed 100%)'
                      : '#007DCC',
                    color: isDarkMode ? '#ffffff' : '#ffffff',
                    textTransform: 'capitalize',
                    borderRadius: '12px',
                    padding: '8px 20px',
                    fontSize: '11px',
                    fontWeight: 700,
                    boxShadow: isDarkMode ? '0 6px 24px rgba(79,70,229,0.45)' : 'none',
                    '&:hover': {
                      background: isDarkMode
                        ? 'linear-gradient(90deg, #4338ca 0%, #6d28d9 100%)'
                        : '#1a1a1a',
                    },
                  }}
                >
                  {loader ? (
                    <div className="flex items-center justify-center gap-2">
                      <Loader />
                      <span>Processing...</span>
                    </div>
                  ) : (
                    <span className="flex items-center justify-center gap-2">
                      <Wallet size={13} />
                      Recharge Now
                    </span>
                  )}
                </Button>
              </form>

              {/* Update Wallet Popup */}
              {isUpdatePopupOpen && (
                <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4">
                  <div className={`rounded-xl p-5 max-w-sm w-full shadow-2xl border relative overflow-hidden
                    ${isDarkMode
                      ? 'bg-gradient-to-br from-[#0b0b14] via-[#0d0d18] to-[#0b0b14] border-indigo-500/30 shadow-[0_8px_40px_rgba(79,70,229,0.35)]'
                      : 'bg-white border-black/10'
                    }`}>
                    <div className="flex justify-between items-center mb-4 relative z-10">
                      <h2 className={`text-sm font-bold ${isDarkMode ? 'text-white' : 'text-black'}`}>
                        Update Wallet Balance
                      </h2>
                      <button
                        onClick={handleCloseUpdatePopup}
                        className={`rounded-full p-1 transition-colors duration-200 ${isDarkMode ? 'text-indigo-300/70 hover:text-white hover:bg-indigo-500/20' : 'text-black/60 hover:text-black hover:bg-black/10'}`}
                      >
                        <X size={18} />
                      </button>
                    </div>

                    <div className="space-y-3 relative z-10">
                      <div>
                        <label className={`block text-[10px] font-semibold mb-1.5 flex items-center gap-1.5 ${isDarkMode ? 'text-indigo-200/80' : 'text-black/70'}`}>
                          <CreditCard size={12} className={isDarkMode ? 'text-indigo-400' : 'text-black/50'} />
                          Transaction ID
                        </label>
                        <input
                          type="text"
                          name="txn_id"
                          value={updateData.txn_id}
                          onChange={handleUpdateInputChange}
                          placeholder="Enter transaction ID"
                          className={`w-full p-2 text-sm border rounded-lg transition-all duration-200 font-medium
                            ${isDarkMode
                              ? 'border-indigo-500/30 bg-black/60 text-white placeholder-indigo-300/40 focus:border-indigo-400 focus:ring-1 focus:ring-indigo-500/60'
                              : 'border-black/20 bg-white text-black placeholder-black/40 focus:border-black focus:ring-1 focus:ring-black'
                            }`}
                          required
                        />
                      </div>

                      <div>
                        <label className={`block text-[10px] font-semibold mb-1.5 flex items-center gap-1.5 ${isDarkMode ? 'text-indigo-200/80' : 'text-black/70'}`}>
                          <CreditCard size={12} className={isDarkMode ? 'text-indigo-400' : 'text-black/50'} />
                          Amount
                        </label>
                        <input
                          type="number"
                          name="amount"
                          min="0"
                          step="1"
                          value={updateData.amount}
                          onChange={handleUpdateInputChange}
                          placeholder="Enter Amount"
                          className={`w-full p-2 text-sm border rounded-lg transition-all duration-200 font-medium
                            ${isDarkMode
                              ? 'border-indigo-500/30 bg-black/60 text-white placeholder-indigo-300/40 focus:border-indigo-400 focus:ring-1 focus:ring-indigo-500/60'
                              : 'border-black/20 bg-white text-black placeholder-black/40 focus:border-black focus:ring-1 focus:ring-black'
                            }`}
                          required
                        />
                      </div>

                      <div>
                        <label className={`block text-[10px] font-semibold mb-1.5 flex items-center gap-1.5 ${isDarkMode ? 'text-indigo-200/80' : 'text-black/70'}`}>
                          <User size={12} className={isDarkMode ? 'text-indigo-400' : 'text-black/50'} />
                          Customer ID
                        </label>
                        <input
                          type="number"
                          name="user_id"
                          value={updateData.user_id}
                          onChange={handleUpdateInputChange}
                          min="0"
                          step="1"
                          placeholder="Enter customer ID"
                          className={`w-full p-2 text-sm border rounded-lg transition-all duration-200 font-medium
                            ${isDarkMode
                              ? 'border-indigo-500/30 bg-black/60 text-white placeholder-indigo-300/40 focus:border-indigo-400 focus:ring-1 focus:ring-indigo-500/60'
                              : 'border-black/20 bg-white text-black placeholder-black/40 focus:border-black focus:ring-1 focus:ring-black'
                            }`}
                          required
                        />
                      </div>

                      <div>
                        <label className={`block text-[10px] font-semibold mb-1.5 flex items-center gap-1.5 ${isDarkMode ? 'text-indigo-200/80' : 'text-black/70'}`}>
                          <ArrowUp size={12} className={isDarkMode ? 'text-indigo-400' : 'text-black/50'} />
                          Type
                        </label>
                        <div className="relative">
                          <select
                            name="type"
                            value={updateData.type}
                            onChange={handleUpdateInputChange}
                            className={`w-full p-2 text-sm border rounded-lg appearance-none font-medium
                              ${isDarkMode
                                ? 'border-indigo-500/30 bg-black/60 text-white focus:border-indigo-400 focus:ring-1 focus:ring-indigo-500/60'
                                : 'border-black/20 bg-white text-black focus:border-black focus:ring-1 focus:ring-black'
                              }`}
                          >
                            <option value="add">Add</option>
                            <option value="deduct">Deduct</option>
                          </select>
                          <div className="absolute inset-y-0 right-0 flex items-center px-2.5 pointer-events-none">
                            <svg className={`h-4 w-4 ${isDarkMode ? 'text-indigo-300/60' : 'text-black/40'}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                              <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                            </svg>
                          </div>
                        </div>
                      </div>

                      <div className={`flex justify-end gap-2 mt-4 pt-3 border-t ${isDarkMode ? 'border-indigo-500/20' : 'border-black/10'}`}>
                        <button
                          type="button"
                          onClick={handleCloseUpdatePopup}
                          className={`px-4 py-1.5 text-[10px] font-semibold rounded-lg transition-all duration-200 border ${isDarkMode ? 'border-indigo-500/40 text-indigo-200 hover:bg-indigo-500/15' : 'border-black/20 text-black hover:bg-black/10'}`}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          onClick={handleUpdateWallet}
                          className={`px-4 py-1.5 text-[10px] font-semibold rounded-lg transition-all duration-200 flex items-center justify-center min-w-[80px] ${isDarkMode ? 'bg-gradient-to-r from-indigo-600 to-purple-600 text-white hover:from-indigo-500 hover:to-purple-500 shadow-lg shadow-indigo-900/50' : 'bg-black text-white hover:bg-black/90'}`}
                        >
                          {updateLoader ? (
                            <div className={`w-4 h-4 border-2 ${isDarkMode ? 'border-white' : 'border-white'} border-t-transparent rounded-full animate-spin`}></div>
                          ) : (
                            <span className="flex items-center gap-1.5">
                              <CheckCircle size={12} />
                              Submit
                            </span>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Terms & Conditions Section */}
            <div className={`lg:col-span-2 border shadow-sm rounded-xl p-4 relative h-full overflow-y-auto custom-scrollbar
              ${isDarkMode
                ? 'bg-gradient-to-br from-[#0b0b14] via-[#0d0d18] to-[#0b0b14] border-indigo-500/20 shadow-[0_8px_40px_rgba(79,70,229,0.12)]'
                : 'bg-white border-black/10'
              }`}>
              <div className="relative z-10">
                <div className="flex items-center gap-2 mb-3">
                  <div className={`w-1 h-5 rounded-full ${isDarkMode ? 'bg-gradient-to-b from-indigo-500 to-purple-600' : 'bg-red-600'}`}></div>
                  <h1 className={`font-extrabold text-[13px] uppercase tracking-wide ${isDarkMode ? 'text-white' : 'text-red-600'}`}>
                    Terms & Conditions for Wallet Top-Up
                  </h1>
                </div>

                <div className={`border-l-4 p-2.5 rounded-r-lg mb-3
                  ${isDarkMode
                    ? 'border-indigo-500 bg-indigo-500/10 backdrop-blur-sm'
                    : 'border-red-600 bg-black/5'
                  }`}>
                  <p className={`font-medium text-[10px] leading-relaxed ${isDarkMode ? 'text-indigo-100/90' : 'text-black/80'}`}>
                    These Terms & Conditions ("T&Cs") govern the top-up of funds
                    ("Top-Up") into your wallet account ("Wallet") on PICKUPXPRESS. By
                    topping up your Wallet, you agree to these T&Cs.
                  </p>
                </div>

                <div className="space-y-2.5">
                  {[
                    {
                      title: "1. Eligibility",
                      content: "* You must be a registered user of the PICKUPXPRESS to top up your Wallet.\n* You must comply with all applicable laws and regulations when topping up your Wallet."
                    },
                    {
                      title: "2. Top-Up Process",
                      content: "* To add funds to your Wallet, you may use the available payment methods supported by the PICKUPXPRESS, including credit/debit cards, bank transfers, Wallet/UPI.\n* All Top-Up transactions are final and cannot be reversed or refunded unless required by law or expressly stated in these T&Cs.\n* The minimum and maximum amounts for a Top-Up are subject to limits as determined by the Platform from time to time."
                    },
                    {
                      title: "3. Processing of Funds",
                      content: "* Funds topped up into your Wallet will show in your balance within 0-36 hours depending on the payment method used.\n* The Platform is not responsible for delays caused by the payment processing service or other third parties.\n* The Wallet balance is non-transferable and can only be used for services on the PICKUPXPRESS platform."
                    },
                    {
                      title: "4. Fees and Charges",
                      content: "* The Platform may charge fees for Top-Up transactions, which will be disclosed at the time of the transaction.\n* Any applicable fees or taxes, including foreign exchange fees for cross-border transactions, will be borne by the user."
                    },
                    {
                      title: "5. Usage of Wallet Funds",
                      content: "* Funds in your Wallet can only be used for transactions within the PICKUPXPRESS.\n* Wallet funds cannot be withdrawn, transferred, or redeemed for cash, except where required by law or as specified by the PICKUPXPRESS."
                    },
                    {
                      title: "6. Account Security",
                      content: "* You are responsible for maintaining the security of your account and ensuring that your login credentials are not shared with others.\n* The Platform is not liable for any unauthorized access to your account or Wallet due to your negligence."
                    },
                    {
                      title: "7. Expiration and Forfeiture of Funds",
                      content: "* Wallet balances may expire or be subject to forfeiture after a specified period of inactivity as determined by the PICKUPXPRESS policies.\n* The Platform will provide reasonable notice before any such expiration or forfeiture of funds."
                    },
                    {
                      title: "8. Fraud Prevention",
                      content: "* The PICKUPXPRESS reserves the right to suspend or terminate your account and Wallet, and to investigate any Top-Up transaction suspected of being fraudulent or in violation of these T&Cs.\n* Any attempt to defraud the PICKUPXPRESS or misuse the Wallet will result in legal action and forfeiture of funds."
                    },
                    {
                      title: "9. Changes to Terms & Conditions",
                      content: "* The Platform reserves the right to modify these T&Cs at any time. Any changes will be communicated to users through the PICKUPXPRESS or via email.\n* Continued use of the Wallet after changes to these T&Cs will constitute acceptance of the modified terms."
                    },
                    {
                      title: "10. Governing Law",
                      content: "* Any disputes arising out of or related to these T&Cs will be subject to the exclusive jurisdiction of the courts of Gautam Budh Nagar/India."
                    },
                    {
                      title: "11. Contact Information",
                      content: "If you have any questions or concerns regarding these T&Cs, please contact our support team at [support@pickupxpress.com]."
                    }
                  ].map((section, index) => (
                    <div key={index} className="group">
                      <div className="flex items-start gap-2 mb-0.5">
                        <div className={`w-1 h-1 rounded-full mt-1.5 ${isDarkMode ? 'bg-indigo-400' : 'bg-black/50'}`}></div>
                        <h3 className={`font-bold text-[10px] transition-colors duration-200 ${isDarkMode ? 'text-indigo-200' : 'text-red-600'}`}>
                          {section.title}
                        </h3>
                      </div>
                      <div className={`ml-4 pl-3 border-l ${isDarkMode ? 'border-indigo-500/20' : 'border-red-600'}`}>
                        <p className={`font-medium text-[9px] leading-relaxed whitespace-pre-line ${isDarkMode ? 'text-indigo-100/60' : 'text-black/60'}`}>
                          {section.content}
                        </p>
                      </div>
                    </div>
                  ))}

                  {/* Payment Methods Section */}
                  <div className={`mt-4 p-3 border rounded-xl
                    ${isDarkMode
                      ? 'border-indigo-500/25 bg-indigo-500/5 backdrop-blur-sm'
                      : 'border-black/10 bg-black/5'
                    }`}>
                    <div className="flex items-center gap-1.5 mb-2">
                      <div className={`w-1 h-1 rounded-full ${isDarkMode ? 'bg-indigo-400' : 'bg-black'}`}></div>
                      <h3 className={`font-bold text-[10px] ${isDarkMode ? 'text-indigo-200' : 'text-black'}`}>
                        Payment Methods Supported:
                      </h3>
                    </div>

                    <div className="grid grid-cols-2 gap-2">
                      <div className={`p-2 rounded-lg border
                        ${isDarkMode
                          ? 'bg-black/60 border-indigo-500/25'
                          : 'bg-white border-black/10'
                        }`}>
                        <h4 className={`font-semibold text-[9px] mb-1 ${isDarkMode ? 'text-indigo-200' : 'text-black'}`}>Credit/Debit Cards:</h4>
                        <ul className={`space-y-0.5 text-[9px] font-medium ${isDarkMode ? 'text-indigo-100/60' : 'text-black/60'}`}>
                          <li>• Visa</li>
                          <li>• MasterCard</li>
                          <li>• American Express</li>
                          <li>• Discover</li>
                        </ul>
                      </div>

                      <div className={`p-2 rounded-lg border
                        ${isDarkMode
                          ? 'bg-black/60 border-indigo-500/25'
                          : 'bg-white border-black/10'
                        }`}>
                        <h4 className={`font-semibold text-[9px] mb-1 ${isDarkMode ? 'text-indigo-200' : 'text-black'}`}>Digital Wallets:</h4>
                        <ul className={`space-y-0.5 text-[9px] font-medium ${isDarkMode ? 'text-indigo-100/60' : 'text-black/60'}`}>
                          <li>• Paytm</li>
                          <li>• Google Pay</li>
                          <li>• PhonePe</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default B2bWalletRecharge;